import React from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
//import 'react-activity/lib/Dots/Dots.css';
import "../../../node_modules/video-react/dist/video-react.css";
import { withStyles } from '@mui/styles';
import SoundDefinition from './SoundDefinition'
import '../../i18n'
import { withTranslation } from 'react-i18next'
import MusicNoteIcon from '@mui/icons-material/MusicNote';
import 'bootstrap/dist/css/bootstrap.min.css';


const styles = theme => ({
  fab: {
    margin: theme.spacing,
  },
  absolute: {
    position: 'absolute',
    bottom: theme.spacing,
    right: theme.spacing,
  },
});

class SoundDefinitionModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      sound: this.props.sound,

    };


  this.toggle = this.toggle.bind(this);

  }

  static getDerivedStateFromProps(props, state) {

    if ( props.sound !== state.sound ){
      console.log('getderived from sounddefmodal: ', props.sound)
      return {
        sound: props.sound
      }
    }
    return null;
  }


  async toggle(){


    if (!this.state.modal){


      console.log('sounddefinitionmodal: ', this.props.soundData)

    }



    this.setState({ modal: !this.state.modal})
  }


  choosenSoundCallback(sound){
      this.props.callback(sound)
      this.setState({sound})
      this.toggle()
  }


  render() {

    const {t} = this.props;


    return (
      <div>


        {
        this.state.sound && this.state.sound.hasOwnProperty('id') ?
        <Button color="primary" onClick={this.toggle}>
          <MusicNoteIcon />
          {this.state.sound.title} - {this.state.sound.artistName} - {t('storyboard.sounddefinitionmodal.changemusic')} </Button>
        : <Button color="primary" onClick={this.toggle}>{this.props.buttonLabel}</Button>
        }

        <Modal size="xl" style={{ maxWidth: '1600px', width: '80%' }} isOpen={this.state.modal} toggle={this.toggle} >



          <ModalHeader toggle={this.toggle}>{t('storyboard.sounddefinitionmodal.musicselection')} {this.props.id}</ModalHeader>
          <ModalBody>
          <SoundDefinition sounds={this.props.sounds} callback={(c) => this.choosenSoundCallback(c)} />

	          </ModalBody>
          <ModalFooter>


			<Button  color="primary" onClick={() => this.toggle()}>{t('storyboard.sounddefinitionmodal.close')}</Button>



          </ModalFooter>



        </Modal>


      </div>
    );
  }
}

export default withTranslation()(withStyles(styles)(SoundDefinitionModal));
